import { Card, getPaletteColor } from 'pcln-design-system'
import styled from 'styled-components'

export interface BannerWrapperProps {
  bgColor?: string
  borderHugTop?: string
  borderHugLeft?: string
  outline?: string
  hoverBoxShadowSize?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'
}

const BannerWrapper = styled(Card)<BannerWrapperProps>`
  position: relative;

  ${(props) => `
    background-color: ${getPaletteColor(props.bgColor ?? 'background.lightest')(props)};
    ${props.outline ? `border-color: ${getPaletteColor(props.outline)(props)}` : 'border-width: 0px'};
    ${
      props.borderHugLeft &&
      `border-left-width: 4px; border-left-color: ${getPaletteColor(props.borderHugLeft)(props)};`
    }
    ${
      props.borderHugTop &&
      `border-top-width: 4px; border-top-color: ${getPaletteColor(props.borderHugTop)(props)};`
    };

    ${
      props.hoverBoxShadowSize &&
      `transition: box-shadow ${props.theme.timingFunctions.easeInOut} ${props.theme.duration.normal};
      &:hover { box-shadow: ${props.theme.shadows.xl}; }`
    }
  `};
`

export default BannerWrapper
